import AlertModalAction from "@common/redux/actions/AlertModalAction";

export const handleSuccess = (message, history, redirectPath) => {
  AlertModalAction.open(
    message,
    "Success",
    history ? () => history.push(redirectPath) : () => {},
  );
};
